import { render, staticRenderFns } from "./menu-lateral.vue?vue&type=template&id=61f287ee&scoped=true&"
import script from "./menu-lateral.vue?vue&type=script&lang=js&"
export * from "./menu-lateral.vue?vue&type=script&lang=js&"
import style0 from "./menu-lateral.vue?vue&type=style&index=0&id=61f287ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f287ee",
  null
  
)

export default component.exports